import React from 'react'
import Page from '../../components/page/page'
import TeacherBasePage from '../../components/teacher-base-page/teacher-base-page'

const TeacherIndex = () => {
    return (
        <Page isModal={false}>
            <TeacherBasePage>
                <div>1313</div>
            </TeacherBasePage>
        </Page>
    )
}

export default TeacherIndex
